/* eslint-disable react-hooks/exhaustive-deps */
'use client'
import { useEffect, useState } from 'react'
import { ArticleCardData } from '@/globalTypes'
import { Skeleton } from '@mui/material'
import ArticleCard from './ArticleCard'
import { getAllArticles } from '@/services/app.services'



const ArticleList = ({ baseClass, baseURL }: { baseClass: string, baseURL: string }) => {
    const [articleList, setArticleList] = useState([]);
    
    useEffect(() => {
        (async () => {
            let response:any = await getAllArticles();
            if (response) {
                setArticleList(response);
            } else {
                console.error(response);
            }
        })()
    }, [])



    return (
        <div className={`${baseClass}__article-list min-h-screen grid gap-8 p-6  `}>
            {
                articleList.length ?
                    (articleList.map((article: ArticleCardData) => {
                        return <ArticleCard key={article.id} baseClass={baseClass} article={article} baseURL={baseURL} />
                    }))
                    :
                    (

                        [1, 2, 3, 4, 5, 6, 7, 8, 9].map(() => {

                            return <div key={Math.random()} className={`${baseClass}__article grid gap-6  rounded-2xl bg-white shadow-articleCard text-[#1D4749] font-bold p-6 w-[100%] md:w-[70%] xl:w-[50%]  mx-auto `}>
                                <div className={`${baseClass}__article__heading  h-max capitalize text-base`}>
                                    <Skeleton variant='text' width={100} height={16} />
                                </div>
                                <div className={`${baseClass}__article__sub-headings  w-full inline-grid gap-5 grid-cols-2   `} >
                                    {[1].map(() => {
                                        return (
                                            [1, 2, 3, 4].map(() => {
                                                // eslint-disable-next-line react/jsx-key
                                                return <Skeleton variant='text' width={'100%'} height={100} />


                                            })
                                        )
                                    })}
                                </div>
                            </div>
                        })


                    )
            }

        </div>
    )
}

export default ArticleList